export default __webpack_public_path__ + "static/media/glass-cover.d3012876.svg";